import CuentasBancarias from "../../components/CuentasBancarias";

const CuentasBancariosPage = () => <CuentasBancarias />;

export default CuentasBancariosPage;
